<template>
    <div class="field mb-m-0">
        <label class="label">Displacement range</label>
        <div class="field has-addons">
            <p class="control">
                <input class="input" v-model="minCC" placeholder="Min value"/>
            </p>
            <p class="control helper-to">
                <span class="button is-static">To:</span>
            </p>
            <p class="control">
                <input class="input" v-model="maxCC" placeholder="Max value"/>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            minCC: {
                get: function () {
                    return this.$store.getters.getQueryCCMinStock
                },
                set: function (value) {
                    value = value.length > 0 ? value : null
                    this.$store.dispatch('addNewCCRangeMinValueStock', value)
                }
            },
            maxCC: {
                get: function () {
                    return this.$store.getters.getQueryCCMaxStock
                },
                set: function (value) {
                    value = value.length > 0 ? value : null
                    this.$store.dispatch('addNewCCRangeMaxValueStock', value)
                }
            }
        }
    }
</script>

<style scoped>
    .control {
        width: 100%;
    }
    .helper-to {
        width: 50px;
    }
</style>



// WEBPACK FOOTER //
// src/components/StockCars/DisplacementRangeSliderStock.vue